import { Button } from "@/components/ui/button";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "oidc-react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { ChevronRight } from "lucide-react";
import { COURSES } from "@/data/courseSections";

interface HeaderProps {
  title?: string;
}

const Header = ({ title = "Home" }: HeaderProps) => {
  const navigate = useNavigate();
  const auth = useAuth();
  const { courseSlug } = useParams();

  const course = COURSES.find((course) => course.slug === courseSlug);

  return (
    <header className="sticky top-0 w-full bg-white border-b border-gray-200 py-3">
      <div className="px-4 max-w-full mx-auto flex items-center justify-between">
        <div className="flex items-center gap-4 md:gap-8 min-w-0">
          <a
            onClick={() => navigate("/")}
            className="flex-shrink-0 flex items-center gap-2 cursor-pointer"
          >
            <div className="flex items-center">
              <img
                src="/lovable-uploads/7fea6f91-d3ca-4580-a47b-84013067f33d.png"
                alt="TeachStack Logo"
                className="h-5 object-scale-down"
              />
            </div>
          </a>

          <nav className="hidden md:flex items-center gap-2 text-sm min-w-0">
            <Button
              variant="ghost"
              className="text-teachstack-dark font-medium p-0 h-auto hover:no-underline"
              onClick={() => navigate("/")}
            >
              Home
            </Button>

            {course && (
              <>
                <ChevronRight className="flex-shrink-0 text-gray-400 h-4 w-4" />
                <Button
                  variant="ghost"
                  className="text-teachstack-dark font-medium p-0 h-auto truncate"
                  onClick={() => navigate(`/course/${courseSlug}`)}
                >
                  {course.title}
                </Button>
              </>
            )}
          </nav>
        </div>

        <div className="flex items-center">
          <Button
            variant="ghost"
            className="flex items-center gap-2 text-sm font-medium"
          >
            <Avatar className="h-8 w-8 flex-shrink-0">
              <AvatarFallback className="bg-gray-200">
                {/* @ts-ignore */}
                {auth.userData.profile.username[0].toUpperCase()}
              </AvatarFallback>
            </Avatar>
            <span className="hidden md:inline">
              {/* @ts-ignore */}
              {auth.userData.profile.username}
            </span>
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
